import { render, staticRenderFns } from "./MyRequests.vue?vue&type=template&id=b2e8b5a2&"
import script from "./MyRequests.vue?vue&type=script&lang=js&"
export * from "./MyRequests.vue?vue&type=script&lang=js&"
import style0 from "./MyRequests.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports